export const getRowAnimationDelay = (rowIndex: number) => {
  return 0.1 * (rowIndex + 1);
};

/** Written as a DOM attribute one side, matched as a CSS selector the other, so
 *  the two cannot be renamed independently. */
export const SKIP_HIGHLIGHT_ATTRIBUTE = "data-skip-highlight";
